import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const DiseaseList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="disease"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default DiseaseList;
